export const resolveOrgLevel = (user) => {
  if (String(user?.role || "").toLowerCase() === "super_admin") return 1;
  const raw = Number(user?.org_level);
  if ([1, 2, 3].includes(raw)) return raw;
  if (user?.is_pod_owner) return 2;
  return 3;
};

export const canCreatePortfolio = (user) => resolveOrgLevel(user) <= 2;

export const canSeeScorecard = (user) => resolveOrgLevel(user) <= 2;

export const canSeeOrgEditor = (user) => resolveOrgLevel(user) === 1;
